<template lang="pug">
  .modal.fade.calendar-config(ref='modal')
    .modal-dialog
      .modal-content
        .modal-header
          button.close(type="button", data-dismiss="modal", aria-hidden="true") &#215;
          h4.modal-title 
            vue-object-img(:object="selectedGroup", v-if='selectedGroup')
            |  {{$t("events.configurationModal.title")}} 
            template(v-if="selectedGroup") : {{selectedGroup.name}}
        .modal-body
          .padding(v-if='savingState == null')
            template(v-if='!selectedGroup')
              .groupLine(v-for='group in sortedGroops', role='button', @click='selectedGroup = group')
                vue-object-img(:object='group')
                |  {{group.name}}
                .pull-right
                  .color(:style='colorBtnStyle(group)')
                  i.fa.fa-cog
            form.form-horizontal(role="form", v-else)
              .form-group
                .form-group
                  label.col-sm-2 {{$t('events.configurationModal.color.title')}}
                  .col-sm-10
                    input(type="color", v-model="color", style='width:100%; height: 40px')
                    .help-block {{$t('events.configurationModal.color.description')}}
                hr
                .pull-right
                  toggle-button(v-model="expectAnswer")
                label
                  |  {{$t('events.configurationModal.expectAnswer.title')}}&nbsp;&nbsp;&nbsp;
                  i.fa.fa-user(:class='{needOwnAnswer: expectAnswer}')
                hr
                .form-group
                  label.col-sm-2 {{$t('events.configurationModal.exportExcel.title')}}
                  .col-sm-10
                    .text-muted {{$t('events.configurationModal.exportExcel.help')}}
                    p
                    a.btn.btn-default(@click="downloadExcel") {{$t('events.configurationModal.exportExcel.btn')}}
                hr
                .form-group
                  label.col-sm-2 
                    | {{$t('events.configurationModal.export.title')}}
                  .col-sm-10
                    template(v-if='!showICSLink')
                      .help-block {{$t('events.configurationModal.export.title')}}
                      p
                        //- .checkbox.clear
                        //-   label
                        //-     input(type='checkbox', v-model='hideEvents')
                        //-     | {{$t('events.configurationModal.export.optionIncludeRefused')}}
                        .radio.clear
                          label
                            input(type='radio', value="all", v-model='exportEventsVersion')
                            | {{$t('events.configurationModal.export.optionAll')}}
                        .radio.clear
                          label
                            input(type='radio', value="notRefused", v-model='exportEventsVersion')
                            | {{$t('events.configurationModal.export.optionAllButRefused')}}
                        .radio.clear
                          label
                            input(type='radio', value="onlyAccepted", v-model='exportEventsVersion')
                            | {{$t('events.configurationModal.export.optionOnlyAccepted')}}
                        // radio buttons :
                        // - Tous les événements (r=0)
                        // - Tous les événements sauf les refusés (rien)
                        // - Les événements que j'ai acceptés (a=1)
                      a.btn.btn-default(@click="toggleShowICSLink") {{$t('events.configurationModal.export.btnToICalLink')}}
                    template(v-else)
                      .help-block {{$t('events.configurationModal.export.link.description')}}
                      ul(v-html='$t("events.configurationModal.export.link.warning")')
                        
                      .alert.alert-info(style='overflow-wrap: break-word')
                        | {{$t('events.configurationModal.export.link.toCopy')}}
                        br
                        a(:href='calendarICSPath', rel='noopener', target='_blank') {{calendarICSPath}}
                      a.btn.btn-xs.btn-default(@click="toggleShowICSLink") 
                        i.fa.fa-arrow-left 
                        |  {{$t('events.configurationModal.export.link.back')}}
                  

          .bigIconMessage(v-if='savingState == "saving"')
            i.fa.fa-refresh.fa-spin.grey
            |  {{$t("globals.sending")}}
          .bigIconMessage(v-if='savingState == "saved"')
            i.fa.fa-check.green
            |  {{$t("globals.saved")}}

          .bigIconMessage(v-if='savingState == "error"')
            i.fa.fa-remove.red
            |  {{$t("globals.error")}}

        .modal-footer(v-if='savingState == null')
          button.btn.btn-default.pull-left(type="button", @click='selectedGroup = null', v-if='selectedGroup') {{$t('events.configurationModal.seeGroupListButton')}}
          //- button.btn.btn-primary(type="button")
            | {{$t('globals.save')}}
</template>
<script>
import modalsBus from '@/components/shared/ModalsBus'
import ToggleButton from 'vue-js-toggle-button/src/Button'

import $ from 'jquery'

import VueSelectAGroup from '@/components/shared/SelectAGroup'
import VueObjectImg from '@/components/shared/VueObjectImg'

import {mapGetters} from 'vuex'
import api from '@/utils/api'

import groops from '@/store/groops'

import eventsBus from '@/components/shared/EventsBus'

import _ from 'lodash'

export default {
  props: {
    eventsBus: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      savingState: null,
      selectedGroup: null,
      color: '#000000',
      expectAnswer: true,
      hideEvents: true,
      showICSLink: false,
      exportEventsVersion: 'all'
    }
  },
  components: {
    VueSelectAGroup,
    VueObjectImg,
    ToggleButton
  },
  mounted () {
    modalsBus.onOpen((arg) => {
      if (arg === modalsBus.modals.CONFIGURE_CALENDAR) {
        this.openModal()
      } else {
        this.closeModal()
      }
    })
    modalsBus.onCloseAll(() => {
      this.closeModal()
    })
  },
  computed: {
    ...mapGetters('groops', [
      'groops',
      'groopsAreLoaded',
      'isAllGroopsSelected',
      'firstSelectedGroop'
    ]),
    ...mapGetters('user', [
      'user'
    ]),
    mustHaveIsComplete () {
      return true
    },
    sortedGroops () {
      return _.sortBy(this.groops, (g) => 0 - g.lastNotificationTime)
    },
    calendarICSPath () {
      if (!this.selectedGroup) {
        return null
      }
      let url = api.getUrl('calendar/ical/' + this.user.id + '/' + groops.getGroopsIds([this.selectedGroup]) + '/' + this.selectedGroup.registrationKey, false)
      if (this.exportEventsVersion === 'all') {
        url += '?r=0'
      } else if (this.exportEventsVersion === 'onlyAccepted') {
        url += '?a=1'
      }
      return url
    }
  },
  methods: {
    openModal () {
      this.selectedGroup = this.isAllGroopsSelected ? null : this.firstSelectedGroop
      $(this.$refs.modal).modal('show')
    },
    closeModal () {
      $(this.$refs.modal).modal('hide')
    },
    toggleShowICSLink () {
      this.showICSLink = !this.showICSLink
    },
    cancel () {},
    change () {},
    colorBtnStyle (groop) {
      return {
        'background-color': groop.color
      }
    },
    downloadExcel () {
      api.getUrl('calendar/excel/' + this.selectedGroup.id).then((url) => {
        window.location = url
      })
    }
  },
  watch: {
    selectedGroup () {
      this.color = this.selectedGroup ? this.selectedGroup.color : '#000000'
      this.expectAnswer = this.selectedGroup ? this.selectedGroup.expectAnswer : false
      this.showICSLink = false
    },
    expectAnswer (value) {
      if (this.selectedGroup && this.selectedGroup.expectAnswer !== value) {
        this.selectedGroup.expectAnswer = value
        api.put('/group/' + this.selectedGroup.id + '/preferences', {
          expectAnswer: value
        }).then(() => {
          eventsBus.$emit(eventsBus.UPDATED_EVENT, {})
        })
      }
    },
    color: _.debounce(function () {
      if (this.selectedGroup && this.selectedGroup.color !== this.color) {
        this.selectedGroup.color = this.color
        api.put('/group/' + this.selectedGroup.id + '/member/' + this.user.id, {
          color: this.color
        }).then(() => {
          eventsBus.$emit(eventsBus.UPDATED_GROUP_COLOR, {group: this.selectedGroup})
        }).catch(() => {
          // todo
        })
      }
    }, 200)
  }
}
</script>
<style lang="sass">
.calendar-config
  .groupLine
    padding: 5px
    border-radius: 5px
    .profileImage
      $size: 30px
      height: $size
      width: $size
      line-height: $size
    &:hover
      background-color: #EEE
  .color
    display: inline-block
    $size: 30px
    height: $size
    width: $size
    line-height: $size
    vertical-align: middle
    margin-right: 10px
    border-radius: 50%

</style>



// WEBPACK FOOTER //
// Events-ConfigurationModal.vue?70cf64ae